<template>
  <div>
      <section class="content">
        <!-- /.box -->
        <div class="box info-box">
          <div class="box-header with-border">
            Search By
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-md-3" v-if="canAccess('branch-create')">
                <label for="Branch">Branch</label>
                <v-select v-model="branchFilter" name="branch_id" label="name" :options="branches" v-on:input="branchRecordWithLoadSettlementData" placeholder="Select Branch"></v-select>
                <has-error
                  :form="form"
                  field="branch_id"
                ></has-error>
              </div>
              <div class="col-md-3" v-if="form.planType == 'group'"> 
                <label>Collection Center </label>
                <v-select v-model="colC"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="loadSettlementData" required> 
                </v-select>
              </div>
              <div class="col-md-3"> 
                <label>Customer</label>
                <v-select v-model="member"  name="collection_center_id" label="name" :options="members" placeholder="Select Group" v-on:input="loadSettlementDataWithCustomer" required> 
                </v-select>
              </div>
              <div class="col-md-3">
                <label for="date">Date</label>
                <input type="date" v-model="form.paymentDate" name="paymentDate" @change="loadSettlementData(1)" class="form-control" placeholder="EMI Date">
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label
                    >Select Status <span class="red">*</span></label
                  >
                  <select
                    v-model="form.status"
                    name="status"
                    class="form-control"
                    @change="loadSettlementData"
                    :class="{
                      'is-invalid': form.errors.has('status'),
                    }"
                  >
                    <option v-if="!form.status" selected value="">
                      Select Status
                    </option>
                    <option value="pending">Pending</option>
                    <option value="processing">Processing</option>
                    <option value="sattlement">Settlement</option>
                    <option value="complete">Complete</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- Default box -->
        <div class="info-box"  v-if="canAccess('bank-view-any')">
          <div class="box-header with-border">
            <h3 class="box-title">Records</h3>
            
            <div class="box-tools">
              <button type="button" class="btn btn-success btn-sm" @click="newModalForclosure" v-if="canAccess('sattlement-create')">
                <i class="fa fa-plus"></i> Loan ForClosure
              </button>
              <button type="button" class="btn btn-warning btn-sm" @click="newModalSettlement" v-if="canAccess('sattlement-create')">
                <i class="fa fa-laptop"></i> Loan Settlement
              </button>
            </div>
  
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 col-xs-6">
                <label>
                  <select v-model="per_page" name="per_page" @change="loadSettlementData()" aria-controls="example1" class="form-control input-sm">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <div class="col-sm-6 col-xs-6">
                <div class="input-group pull-right input-group-sm" style="width: 150px;">
                  <input type="text" v-model="table_search" @keyup.enter="loadSettlementData()" name="table_search" class="form-control pull-right" placeholder="Search">
  
                  <div class="input-group-btn">
                    <button type="button" @click="loadSettlementData()" class="btn btn-default"><i class="fa fa-search"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <table class="table table-sm table-bordered table-hover">
              <thead style="background-color: #d6dddd;">
                <tr>
                  <th class="hidden-xs">Sr. No.</th>
                  <th>Loan Id</th>
                  <th class="hidden-xs">Mem Name</th>
                  <th class="hidden-xs">(C/O) Alias</th>
                  <th class="hidden-xs">Mem Mob</th>
                  <th class="hidden-xs">Plan Amt</th>
                  <th class="hidden-xs">Paid Amt</th>
                  <th class="hidden-xs">Due Amt</th>
                  <th class="hidden-xs">Settle Amt</th>
                  <th class="hidden-xs">Settle Date</th>
                  <th class="hidden-xs">Created By</th>
                  <th class="hidden-xs">Pay Mode</th>
                  <th class="hidden-xs">Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in rows.data" :key="index">
                  <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                  <td>{{ row.member_loan_plan.applicationNo }}</td>
                  <td class="hidden-xs">{{ row.member.name }} - {{ row.member.code }}</td>
                  <td class="hidden-xs">{{ row.member.alias }}</td>
                  <td class="hidden-xs">{{ row.member.mobile }}</td>
                  <td class="hidden-xs">{{ row.planAmount }}</td>
                  <td class="hidden-xs">{{ row.totalAmountPaid }}</td>
                  <td class="hidden-xs">{{ row.totalAmountDue }}</td>
                  <td class="hidden-xs">{{ row.totalAmountPaidWithSettlement }}</td>
                  <td class="hidden-xs">{{ row.sattlementDate | myDate }}</td>
                  <td class="hidden-xs">{{ row.created_by.name }}</td>
                  <td class="hidden-xs">{{ row.branch_ledger.ledger.name }}</td>
                  <td class="hidden-xs">{{ row.status }}</td>
                  <td>
                    <div class="btn-group">
                      <button v-if="row.status !== 'approved'"
                        @click="editModal(row)"
                        class="btn btn-success btn-xs"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        @click="viewModal(row)"
                        class="btn btn-success btn-xs"
                      >
                        <i class="fa fa-eye"></i>
                      </button>
                      <button
                        v-if="canAccess('loan-disbursement-delete')"
                        @click="deleteModal(row.id)"
                        class="btn btn-danger btn-xs"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
                  
          </div>
          <!-- /.box-body -->
          <div class="box-footer clearfix" v-if="pagination.current_page > 0">
            <div class="row">
              <div class="col-sm-4">
                Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
              </div>
              <div class="col-sm-8">
                <ul class="pagination pagination-sm no-margin pull-right">
                  <li @click="loadSettlementData(null, 'first')"><a href="#">&laquo;</a></li>
                  <li @click="loadSettlementData(null, 'prev')"><a href="#">Prev</a></li>
  
                  <!-- <li v-if="pagination.current_page > 4" @click="loadSettlementData( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page > 3" @click="loadSettlementData( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                  <li v-if="pagination.current_page > 2" @click="loadSettlementData( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                  <li v-if="pagination.current_page > 1" @click="loadSettlementData( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                  <li class="active" @click="loadSettlementData( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="loadSettlementData( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="loadSettlementData( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                  <li><a href="#">...</a></li>
                  
                  <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="loadSettlementData( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                  <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="loadSettlementData( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="loadSettlementData( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                  <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="loadSettlementData( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                  <li @click="loadSettlementData( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>
  
                  <li @click="loadSettlementData(null, 'next')"><a href="#">Next</a></li>
                  <li @click="loadSettlementData(null, 'last')"><a href="#">&raquo;</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- /.card -->
        <div class="modal fade" id="viewModal">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Settlement Details</h4>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="card">
                
                      <!-- /.card-header -->
                      <div class="card-body" v-if="settlementDetails">
                        <ul class="todo-list ui-sortable" data-widget="todo-list">
                          <li v-if="settlementDetails.branch">
                            <span class="text">Branch Name : </span> {{settlementDetails.branch.name}}
                          </li>
                          <li v-if="settlementDetails.branch_ledger">
                            <span class="text">Payment Mode : </span> {{settlementDetails.branch_ledger.ledger.name}}
                          </li>
                          <li v-if="settlementDetails.member">
                            <span class="text">Member Name : </span> {{settlementDetails.member.name}}
                          </li>
                          <li v-if="settlementDetails.member">
                            <span class="text">Member code : </span> {{settlementDetails.member.code}}
                          </li>
                          <li v-if="settlementDetails.member">
                            <span class="text">Member Alias : </span> {{settlementDetails.member.alias}}
                          </li>
                          <li v-if="settlementDetails.member">
                            <span class="text">Member Contact Number : </span> {{settlementDetails.member.mobile}}
                          </li>
                          <li v-if="settlementDetails.member">
                            <span class="text">Member Email : </span> {{settlementDetails.member.email}}
                          </li>
                          <li v-if="settlementDetails.member_loan_plan">
                            <span class="text">Loan Application Number : </span> {{settlementDetails.member_loan_plan.applicationNo}}
                          </li>
                          <li v-if="settlementDetails.member_loan_plan">
                            <span class="text">Loan EMI Start Date : </span> {{settlementDetails.member_loan_plan.emiStartDate}}
                          </li>
                          <li v-if="settlementDetails.member_loan_plan">
                            <span class="text">Loan EMI End Date : </span> {{settlementDetails.member_loan_plan.emiEndDate}}
                          </li>
                          <li v-if="settlementDetails.member_loan_plan">
                            <span class="text">Loan Type : </span> {{settlementDetails.member_loan_plan.type}}
                          </li>
                          <li v-if="settlementDetails.collection_center">
                            <span class="text">Collection Center : </span> {{settlementDetails.collection_center.name}}
                          </li>
                          <li>
                            <span class="text">Total Plan amount : </span> {{settlementDetails.planAmount}}
                          </li>
                          <li>
                            <span class="text">Total Amount Paid : </span> {{settlementDetails.totalAmountPaid}}
                          </li>
                          
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card">
                      <ul class="todo-list ui-sortable" data-widget="todo-list">
                        <li>
                          <span class="text">Total Amount Due Without Interest : </span> {{settlementDetails.totalAmountDueWithoutInterest}}
                        </li>
                        <li>
                          <span class="text">Total Amount Due : </span> {{settlementDetails.totalAmountDue}}
                        </li>
                        <li>
                          <span class="text">Total Installment Paid : </span> {{settlementDetails.totalInstallmentPaid}}
                        </li>
                        <li>
                          <span class="text">Total Installment Due : </span> {{settlementDetails.totalInstallmentDue}}
                        </li>
                        <li>
                          <span class="text">Loan Pre Closing Charge Type : </span> {{settlementDetails.loanPreClosingChargeType}}
                        </li>
                        <li>
                          <span class="text">loanPreClosingCharge (%) : </span> {{settlementDetails.loanPreClosingCharge}}
                        </li>
                        <li>
                          <span class="text">Reason : </span> {{settlementDetails.reason}}
                        </li>
                        <li>
                          <span class="text">Settlement Date : </span> {{settlementDetails.sattlementDate}}
                        </li>
                        <li>
                          <span class="text">Remark : </span> {{settlementDetails.remark}}
                        </li>
                        <li v-if="settlementDetails.created_by">
                          <span class="text">Loan Settled By : </span> {{settlementDetails.created_by.name}}
                        </li>
                        <li>
                          <span class="text">Total Amount Paid With Settlement : </span> {{settlementDetails.totalAmountPaidWithSettlement}}
                        </li>
                        <li>
                          <span class="text">Settlement Status : </span> {{settlementDetails.status}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.row -->
        <div class="modal fade" id="newModalForclosure">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Add New For Closure</h4>
                <h4 v-show="editMode" class="modal-title">Update For Closure</h4>
              </div>
              <form @submit.prevent="editMode ? updateForClosure() : createForClosure()">
                <div class="modal-body">
                  <!-- right column -->
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Branch <span class="red">*</span></label>
                              <select
                                v-model="form.branch_id"
                                name="branch_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_id'),
                                }"
                                @change="getMemberAndGroupAndAgent"
                                required
                              >
                                <option v-if="!form.branch_id" selected value="">
                                  Select Branch
                                </option>
                                <option
                                  :value="bra.id"
                                  v-for="bra in branches"
                                  :key="bra.id"
                                >
                                  {{ bra.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="branch_id"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Member <span class="red">*</span></label>
                              <v-select v-model="mem"  name="member_id" label="name" :options="members" placeholder="Select Member" v-on:input="getPreviousLoanRecord(mem.user_id,'processingAndPending')">
                                
                              </v-select>
                              
                              <has-error
                                :form="form"
                                field="member_id"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <table class="table table-sm table-bordered table-hover" v-if="memberloanplans.length > 0">
                              <thead style="background-color: #d6dddd;">
                                <tr>
                                    <th class="hidden-xs">Select</th>
                                    <th>Loan Details </th>
                                    <th>Payment Details</th>
                                    <th class="hidden-xs">Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(mlp, id) in memberloanplans" :key="id">
                                    <td class="hidden-xs"><input type="radio" name="previous_member_loan_plan_id" class="minimal" :value="mlp.id"  v-model="form.previous_member_loan_plan_id" @change="getLoanEMI(mlp)"></td>
                                    <td>
                                        <strong>Application No :</strong> {{ mlp.applicationNo }} <br>
                                        <strong>Plan Name : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'name') }} <br>
                                        <strong>Plan Type : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'planType') }} <br>
                                        <!-- <strong>No Of EMI : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'noOfPayments') }} <br> -->
                                        <strong>Type :</strong> {{ mlp.type }} <br>
                                        <i v-if="mlp.collection_center_id"><strong>Group :</strong>{{ mlp.collection_center.name }} ({{ mlp.collection_center.centerCode }}) <br></i>
                                        <strong>Branch : </strong>{{ mlp.branch.name }}
                                    </td>
                                    <td>
                                        <strong>Payable Amount : </strong>{{ mlp.totalAmt }} <br>
                                        <strong>Plan Amount : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'loanAmount') }} <br>
                                        <strong>Disbursement Amount : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'disbursementAmount') }} <br>
                                        <strong class="text-success">Paid Amount : </strong>{{ mlp.receivedAmt }}<br>
                                        <strong class="text-danger">Due Amount : </strong>{{ mlp.totalAmt - mlp.receivedAmt }}<br>
                                        <strong>Received Penalty : </strong> {{ mlp.receivedPanulty }}
                                    </td>
                                    <td class="hidden-xs">
                                        <strong>Disbursement : </strong>{{ mlp.disbursement.disbursementDate | myDate }}<br>
                                        <strong>First EMI : </strong>{{ mlp.disbursement.emiStartDate | myDate }}<br>
                                        <strong>Last EMI : </strong>{{ mlp.disbursement.emiEndDate | myDate }}
                                    </td>
                                    
                                </tr>
                              </tbody>
                            </table>
                            <p v-if="memberEMIs.length > 0"><strong>EMI Details</strong></p>
                            <table class="table table-sm table-bordered table-hover" v-if="memberEMIs.length > 0">
                              <thead style="background-color: #d6dddd;">
                                <tr>
                                    <th>No of EMI </th>
                                    <th>Paid No of EMI</th>
                                    <th>Due No of EMI</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                    <td>{{ form.previous_no_of_emi }}</td>
                                    <td>{{ form.previous_paid_no_of_emi }}</td>
                                    <td>{{ form.previous_due_no_of_emi }}</td>
                                </tr>
                              </tbody>
                            </table>
                            <!-- text input -->
                          </div>
                          <div class="col-md-6" v-if="memberEMIs.length > 0">
                            <div class="form-group">
                              <label>Payment Date</label>
                              <input
                                type="date"
                                v-model="form.sattlementDate"
                                name="sattlementDate"
                                @change="settmentDateWise"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('sattlementDate'),
                                }"
                              />
                              <has-error :form="form" field="sattlementDate"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                v-model="form.remark"
                                name="remark"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'remark'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="remark"
                              ></has-error>
                            </div>
                            <p>
                              <strong>Due Principal Amount : </strong> {{ form.previous_loan_due_principal_amt }} <br>
                              <strong>Due Interest Amount : </strong> {{ form.previous_loan_due_interest_amt }} <br>
                              <br>
                              <strong>Amount : </strong> {{ paybleAmt }} <br>
                              <strong>Amount With Forclose Charge : </strong> {{ paybleAmtWithForCloseCharge }} <br>
                              <strong>Payable Amount With Discount : </strong> {{ paybleAmtWithDiscount }}
                            </p>
                            
                          </div>
                          <div class="col-md-6" v-if="memberEMIs.length > 0">
                            <div class="form-group">
                              <label
                                >For Close Charge <span class="red">*</span></label
                              >
                              <input
                                v-model="form.loan_forclose_charges"
                                @change="getPaybleAmount"
                                type="number"
                                name="loan_forclose_charges"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('loan_forclose_charges'),
                                }"
                                placeholder="Enter For Close Charges"
                                required
                              />
                              <has-error
                                :form="form"
                                field="loan_forclose_charges"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Write Off Interest Amount <span class="red">*</span></label
                              >
                              <input
                                v-model="form.loan_interest_discount"
                                @change="getPaybleAmount"
                                type="text"
                                name="loan_interest_discount"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('loan_interest_discount'),
                                }"
                                placeholder="Write Off Interest Amount"
                                required
                              />
                              <has-error
                                :form="form"
                                field="loan_interest_discount"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Select Ledger Account </label>
                              <select
                                v-model="form.branch_ledger_id"
                                name="branch_ledger_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_ledger_id'),
                                }"
                              >
                                <option v-if="!form.branch_ledger_id" selected value="">
                                  Select Ledger Account
                                </option>
                                <option
                                  :value="brLedger.id"
                                  v-for="brLedger in payment_ledgers"
                                  :key="brLedger.id"
                                >
                                  {{brLedger.name}} {{brLedger.remark}}
                                </option>
                              </select>
                              <has-error :form="form" field="branch_ledger_id"></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    CREATE
                  </button>
                  <button v-show="editMode" type="submit" class="btn btn-success">
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
        <!-- /.box -->
        <div class="modal fade" id="newModalSettlement">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 v-show="!editMode" class="modal-title">Add New Settlement</h4>
                <h4 v-show="editMode" class="modal-title">Update Settlement</h4>
              </div>
              <form @submit.prevent="editMode ? updateSettlement() : createSettlement()">
                <div class="modal-body">
                  <!-- right column -->
                    <!-- general form elements disabled -->
                    <div class="card card-warning">
                      <!-- /.card-header -->
                      <div class="card-body">
                        <div class="row">
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Branch <span class="red">*</span></label>
                              <select
                                v-model="form.branch_id"
                                name="branch_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_id'),
                                }"
                                @change="getMemberAndGroupAndAgent"
                                required
                              >
                                <option v-if="!form.branch_id" selected value="">
                                  Select Branch
                                </option>
                                <option
                                  :value="bra.id"
                                  v-for="bra in branches"
                                  :key="bra.id"
                                >
                                  {{ bra.name }}
                                </option>
                              </select>
                              <has-error
                                :form="form"
                                field="branch_id"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="form-group">
                              <label>Member <span class="red">*</span></label>
                              <v-select v-model="mem"  name="member_id" label="name" :options="members" placeholder="Select Member" v-on:input="getPreviousLoanRecord(mem.user_id,'processingAndPending')">
                                
                              </v-select>
                              
                              <has-error
                                :form="form"
                                field="member_id"
                              ></has-error>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <table class="table table-sm table-bordered table-hover" v-if="memberloanplans.length > 0">
                              <thead style="background-color: #d6dddd;">
                                <tr>
                                    <th class="hidden-xs">Select</th>
                                    <th>Loan Details </th>
                                    <th>Payment Details</th>
                                    <th class="hidden-xs">Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(mlp, id) in memberloanplans" :key="id">
                                    <td class="hidden-xs"><input type="radio" name="previous_member_loan_plan_id" class="minimal" :value="mlp.id"  v-model="form.previous_member_loan_plan_id" @change="getLoanEMI(mlp)"></td>
                                    <td>
                                        <strong>Application No :</strong> {{ mlp.applicationNo }} <br>
                                        <strong>Plan Name : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'name') }} <br>
                                        <strong>Plan Type : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'planType') }} <br>
                                        <!-- <strong>No Of EMI : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'noOfPayments') }} <br> -->
                                        <strong>Type :</strong> {{ mlp.type }} <br>
                                        <i v-if="mlp.collection_center_id"><strong>Group :</strong>{{ mlp.collection_center.name }} ({{ mlp.collection_center.centerCode }}) <br></i>
                                        <strong>Branch : </strong>{{ mlp.branch.name }}
                                    </td>
                                    <td>
                                        <strong>Payable Amount : </strong>{{ mlp.totalAmt }} <br>
                                        <strong>Plan Amount : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'loanAmount') }} <br>
                                        <strong>Disbursement Amount : </strong> {{ getPlanDetails(mlp.disbursement.plan, 'disbursementAmount') }} <br>
                                        <strong class="text-success">Paid Amount : </strong>{{ mlp.receivedAmt }}<br>
                                        <strong class="text-danger">Due Amount : </strong>{{ mlp.totalAmt - mlp.receivedAmt }}<br>
                                        <strong>Received Penalty : </strong> {{ mlp.receivedPanulty }}
                                    </td>
                                    <td class="hidden-xs">
                                        <strong>Disbursement : </strong>{{ mlp.disbursement.disbursementDate | myDate }}<br>
                                        <strong>First EMI : </strong>{{ mlp.disbursement.emiStartDate | myDate }}<br>
                                        <strong>Last EMI : </strong>{{ mlp.disbursement.emiEndDate | myDate }}
                                    </td>
                                    
                                </tr>
                              </tbody>
                            </table>
                            <p v-if="memberEMIs.length > 0"><strong>EMI Details</strong></p>
                            <table class="table table-sm table-bordered table-hover" v-if="memberEMIs.length > 0">
                              <thead style="background-color: #d6dddd;">
                                <tr>
                                    <th>No of EMI </th>
                                    <th>Paid No of EMI</th>
                                    <th>Due No of EMI</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                    <td>{{ form.previous_no_of_emi }}</td>
                                    <td>{{ form.previous_paid_no_of_emi }}</td>
                                    <td>{{ form.previous_due_no_of_emi }}</td>
                                </tr>
                              </tbody>
                            </table>
                            <!-- text input -->
                          </div>
                          <div class="col-md-6" v-if="memberEMIs.length > 0">
                            <div class="form-group">
                              <label>Payment Date</label>
                              <input
                                type="date"
                                v-model="form.sattlementDate"
                                name="sattlementDate"
                                @change="settmentDateWise"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('sattlementDate'),
                                }"
                              />
                              <has-error :form="form" field="sattlementDate"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Reason </label>
                              <select
                                v-model="form.reason"
                                name="reason"
                                required
                                class="form-control"
                                :class="{ 'is-invalid': form.errors.has('reason') }"
                              >
                                <option value="PrePayment">PrePayment</option>
                                <option value="First Payment Default">X01 -> First Payment Default</option>
                                <option value="Death">X02 -> Death</option>
                                <option value="Willful Default Status">X03 -> Willful Default Status</option>
                                <option value="Untagged">X09 -> Untagged</option>
                                <option value="Not Applicable">X10 -> Not Applicable</option>
                              </select>
                              <has-error :form="form" field="reason"></has-error>
                            </div>
                            <div class="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                v-model="form.remark"
                                name="remark"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has(
                                    'remark'
                                  ),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="remark"
                              ></has-error>
                            </div>
                            <p>
                              <strong>Due Principal Amount : </strong> {{ form.previous_loan_due_principal_amt }} <br>
                              <strong>Due Interest Amount : </strong> {{ form.previous_loan_due_interest_amt }} <br>
                              <br>
                              <strong>Amount : </strong> {{ paybleAmt }} <br>
                              <strong>Amount With Forclose Charge : </strong> {{ paybleAmtWithForCloseCharge }} <br>
                              <strong>Payable Amount With Discount : </strong> {{ paybleAmtWithDiscount }}
                            </p>
                            
                          </div>
                          <div class="col-md-6" v-if="memberEMIs.length > 0">
                            <div class="form-group">
                              <label
                                >For Close Charge <span class="red">*</span></label
                              >
                              <input
                                v-model="form.loan_forclose_charges"
                                @change="getPaybleAmount"
                                type="number"
                                name="loan_forclose_charges"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('loan_forclose_charges'),
                                }"
                                placeholder="Enter For Close Charges"
                                required
                              />
                              <has-error
                                :form="form"
                                field="loan_forclose_charges"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label
                                >Write Off Interest Amount <span class="red">*</span></label
                              >
                              <input
                                v-model="form.loan_interest_discount"
                                @change="getPaybleAmount"
                                type="text"
                                name="loan_interest_discount"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('loan_interest_discount'),
                                }"
                                placeholder="Write Off Interest Amount"
                                required
                              />
                              <has-error
                                :form="form"
                                field="loan_interest_discount"
                              ></has-error>
                            </div>
                            <div class="form-group">
                              <label>Select Ledger Account </label>
                              <select
                                v-model="form.branch_ledger_id"
                                name="branch_ledger_id"
                                class="form-control"
                                :class="{
                                  'is-invalid': form.errors.has('branch_ledger_id'),
                                }"
                              >
                                <option v-if="!form.branch_ledger_id" selected value="">
                                  Select Ledger Account
                                </option>
                                <option
                                  :value="brLedger.id"
                                  v-for="brLedger in payment_ledgers"
                                  :key="brLedger.id"
                                >
                                  {{brLedger.name}} {{brLedger.remark}}
                                </option>
                              </select>
                              <has-error :form="form" field="branch_ledger_id"></has-error>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  
                </div>
                <div class="modal-footer text-center">
                  <button
                    v-show="!editMode"
                    type="submit"
                    class="btn btn-success"
                  >
                    CREATE
                  </button>
                  <button v-show="editMode" type="submit" class="btn btn-success">
                    UPDATE
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                  >
                    CANCEL
                  </button>
                </div>
              </form>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
      </section>
           
  
  </div>
  </template>
  
  <script>
  import GetBranch from '../../mixins/BranchRecords'
  import getPreviousLoan from '../../mixins/PreviousLoanRecord'
  import LoadSettlementData from '../../mixins/SettlementRecords'
  import GetPaymentBranchLedgers from '../../mixins/PaymentBranchLedgers'
  export default {
    name: 'Sattlement',
    mixins: [GetBranch, LoadSettlementData, getPreviousLoan, GetPaymentBranchLedgers],
    data () {
      return {
        pagination: {
          current_page: 0,
          from: 0,
          to: 0,
          total: 0,
          last_page: 0,
          per_page: 0,
          first_page_url: null,
          last_page_url: null,
          next_page_url: null,
          prev_page_url: null,
          path: null
        },
        per_page: 10,
        table_search: '',
        editMode: false,
        branches: [],
        dDtls: {},
        collectionCenters: [],
        branch: {},
        branchFilter: {},
        brLedgers: [],
        brLedger: {},
        members: [],
        payment_ledgers: [],
        memberEMIs: [],
        colC: {},
        memberloanplans: [],
        emiRecords: [],
        emitotal: 0,
        mem: {},
        member: {},
        user_id: '',
        partialEMIRemainder: 0,
        userPlan: {},
        settlementDetails: {},
        paybleAmtWithForCloseCharge: 0,
        form: new Form({
          id: '',
          branch_id: '',
          collection_center_id: '',
          member_id: '',
          member_loan_plan_id: '',
          amt: 0,
          totalInstallmentPaid: 0,
          planAmount: 0,
          totalAmountPaid: 0,
          totalAmountDueWithoutInterest: 0,
          branch_ledger_id: '',
          remark: '',
          reason: '',
          totalInstallmentDue: 0,
          sattlementDate: '',
          totalAmountDue: 0,
          totalAmountPaidWithSettlement: 0,
          status: '',
          loanPreClosingCharge: 0,
          loanPreClosingChargeType: 'percent',
          applicationNumber: '',
          planName: '',
          date: '',
          amount: 0,
          planType: '',
          numberOfEMI: 0,
          totalAmtDueWithPreClosingCharge: 0,
          loan_forclose_charges: 0,
          loan_interest_discount: 0,
          memberName: ''
        }),
        rows: []
      }
    },
    methods: {
      canAccess (perm) {
        return this.$store.state.permissions.includes(perm)
      },
      newModalForclosure () {
        this.memberloanplans = []
        this.memberEMIs = []
        this.mem = {}
        var c = JSON.parse(localStorage.user)
        this.userType = c.type
        $('#newModalForclosure').modal({backdrop: 'static', keyboard: false})
      },
      newModalSettlement () {
        this.memberloanplans = []
        this.memberEMIs = []
        this.mem = {}
        var c = JSON.parse(localStorage.user)
        this.userType = c.type
        $('#newModalSettlement').modal({backdrop: 'static', keyboard: false})
      },
      getMemberAndGroupAndAgent () {
        this.members = []
        this.mem = {}
        var c = JSON.parse(localStorage.user)
        this.userStatus = ''
        var pageUrl = 'member?all=all'
        if (this.getSettingRecord === 'true') {
          pageUrl += '&status=verified'
        }
        if (this.form.branch_id) {
          pageUrl += `&branch_id=${this.form.branch_id}`
        }
        if (c.role.name === 'Agent' || c.role.name === 'Field Officer') {
          pageUrl += `&agent_id=${c.id}`
        }
        this.$axios
          .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.members = data.data
            _.forEach(this.members, function (item, key) {
              this.members[key].name = key + 1 + '- ' + item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
              if (this.form.member_id === item.user.id) {
                this.mem = item
              }
            }.bind(this))
          })
          .catch(
            function (error) {
              if (error.response.data.error) {
                var result = []
                var er = error.response.data.error
                for (var l in er) {
                  if (er.hasOwnProperty(l)) {
                    result.push(l + ': ' + er[l])
                  }
                }
                Toast.fire({ icon: 'error', title: result.join('\n') })
              }
              if (error.response.data.message) {
                let er = error.response.data.message
                Toast.fire({ icon: 'error', title: er })
              }
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
        this.getPaymentBranchLedgers()
      },
      getPlanDetails (plan, val) {
        var planRecord = JSON.parse(plan)
        var value
        switch (val) {
          case 'name': value = planRecord.name
            break
          case 'planType': value = planRecord.planType
            break
          case 'noOfPayments': value = planRecord.noOfPayments
            break
          case 'disbursementAmount': value = planRecord.amount
            break
          case 'loanAmount': value = planRecord.amount
            if (planRecord.processingFeeIncludeAmt === 'true') {
              value = value + planRecord.processingFee
            }
            if (planRecord.fileChargeIncludeAmt === 'true') {
              value = value + planRecord.fileCharge
            }
            if (planRecord.insuranceFeeIncludeAmt === 'true') {
              value = value + planRecord.insuranceFee
            }
        }
        return value
      },
      getLoanEMI (mlp) {
        this.form.previous_disbursement_id = ''
        this.form.previous_member_loan_plan_id = ''
        this.form.previous_remaining_amt = 0
        this.form.previous_loan_amt = ''
        this.form.previous_principal_amt = 0
        this.form.previous_interest_amt = ''
        this.form.previous_paid_amt = ''
        this.form.previous_due_amt = ''
        this.form.previous_no_of_emi = 0
        this.form.previous_paid_no_of_emi = 0
        this.form.previous_due_no_of_emi = ''
        this.form.previous_loan_due_principal_amt = 0
        this.form.previous_loan_due_interest_amt = 0
        this.form.new_disbursement_amt = 0
        this.form.new_loan_amt = 0
        this.form.previous_disbursement_id = mlp.disbursement_id
        this.form.previous_member_loan_plan_id = mlp.id
        this.form.previous_loan_amt = mlp.totalAmt
        this.form.previous_principal_amt = this.getPlanDetails(mlp.disbursement.plan, 'loanAmount')
        this.form.previous_interest_amt = mlp.totalAmt - this.form.previous_principal_amt
        this.form.previous_paid_amt = mlp.receivedAmt
        var receivedAmount = mlp.receivedAmt
        this.form.previous_due_amt = mlp.totalAmt - mlp.receivedAmt
        this.form.previous_loan_due_principal_amt = this.form.previous_principal_amt
        this.form.previous_loan_due_interest_amt = this.form.previous_interest_amt
        this.$axios
        .get('memberemi?all=all&member_loan_plan_id=' + mlp.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.memberEMIs = data.data
          console.log(this.memberEMIs.length)
          if (this.memberEMIs.length > 0) {
            this.form.previous_no_of_emi = this.memberEMIs.length
            this.form.previous_paid_no_of_emi = parseInt(mlp.receivedAmt / (data.data[0].principal + data.data[0].intrest))
            this.form.previous_due_no_of_emi = this.form.previous_no_of_emi - this.form.previous_paid_no_of_emi
            // previous loan due principal amount and interest amount
            for (let i = 0; i < this.memberEMIs.length; i++) {
              if (receivedAmount >= parseInt(this.memberEMIs[i].principal + this.memberEMIs[i].intrest)) {
                // console.log('logic 1')
                // console.log(receivedAmount + ' Receive Amt')
                // console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                // console.log(this.memberEMIs[i].intrest + 'emi interest')
                this.form.previous_loan_due_interest_amt = this.form.previous_loan_due_interest_amt - this.memberEMIs[i].intrest
                console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                console.log(this.memberEMIs[i].principal + ' emi principal')
                this.form.previous_loan_due_principal_amt = this.form.previous_loan_due_principal_amt - this.memberEMIs[i].principal
                console.log(this.form.previous_loan_due_principal_amt + ' Previous Loan Due Principal Amt')
                receivedAmount = receivedAmount - parseInt(this.memberEMIs[i].principal + this.memberEMIs[i].intrest)
                console.log(receivedAmount + ' Receive Amt')
              } else {
                console.log('logic 2')
                if (receivedAmount > 0) {
                  console.log('logic 2.1')
                  if (receivedAmount >= parseInt(this.memberEMIs[i].intrest)) {
                    console.log('logic 2.1.1')
                    console.log(this.memberEMIs[i].intrest + 'emi interest')
                    this.form.previous_loan_due_interest_amt = this.form.previous_loan_due_interest_amt - parseInt(this.memberEMIs[i].intrest)
                    console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                    receivedAmount = receivedAmount - parseInt(this.memberEMIs[i].intrest)
                    console.log(receivedAmount + ' Receive Amt')
                    this.form.previous_loan_due_principal_amt = this.form.previous_loan_due_principal_amt - receivedAmount
                    console.log(this.form.previous_loan_due_principal_amt + ' Previous Loan Due Principal Amt')
                    receivedAmount = 0
                    console.log(receivedAmount + ' Receive Amt')
                  } else {
                    console.log('logic 2.1.2')
                    console.log(this.memberEMIs[i].intrest + 'emi interest')
                    this.form.previous_loan_due_interest_amt = this.form.previous_loan_due_interest_amt - receivedAmount
                    console.log(this.form.previous_loan_due_interest_amt + ' Previous Loan Due Interest Amt')
                    receivedAmount = 0
                    console.log(receivedAmount + ' Receive Amt')
                    // this.form.previous_loan_due_principal_amt = this.form.previous_loan_due_principal_amt - receivedAmount
                  }
                }
              }
            }
            this.paybleAmt = this.form.previous_loan_due_principal_amt + this.form.previous_loan_due_interest_amt
            this.paybleAmtWithForCloseCharge = this.paybleAmt
            this.paybleAmtWithDiscount = this.paybleAmt
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      getPaybleAmount () {
        this.paybleAmtWithForCloseCharge = 0
        this.paybleAmtWithForCloseCharge = this.paybleAmt + parseInt(this.form.loan_forclose_charges)
        if (this.paybleAmtWithForCloseCharge > 0) {
          this.paybleAmtWithDiscount = this.paybleAmtWithForCloseCharge - parseInt(this.form.loan_interest_discount)
        } else {
          this.paybleAmtWithDiscount = this.paybleAmt - parseInt(this.form.loan_interest_discount)
        }
      },
      viewModal (row) {
        this.settlementDetails = row
        $('#viewModal').modal({backdrop: 'static', keyboard: false})
        this.form.fill(row)
      },
      getBranch () {
        this.$axios
          .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.branches = data.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getMembers () {
        var c = JSON.parse(localStorage.user)
        this.userStatus = ''
        if (c.type !== 'admin') {
          if (c.role.name === 'Manager') {
            this.branch_record = `branch_id=${c.agent_profile.branch_id}`
          } else {
            this.branch_record = `&agent_id=${c.id}`
          }
        } else {
          this.branch_record = `branch_id=${this.form.branch_id}`
        }
        if (this.getSettingRecord === 'true') {
          this.userStatus = 'status=verified'
        }
        this.$axios
          .get('member?all=all&' + this.userStatus + '&' + this.branch_record, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.members = data.data
            _.forEach(this.members, function (item, key) {
              this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
              if (this.form.member_id === item.user.id) {
                this.mem = item
              }
            }.bind(this))
          })
          .catch(
            function (error) {
              if (error.response.data.error) {
                var result = []
                var er = error.response.data.error
                for (var l in er) {
                  if (er.hasOwnProperty(l)) {
                    result.push(l + ': ' + er[l])
                  }
                }
                Toast.fire({ icon: 'error', title: result.join('\n') })
              }
              if (error.response.data.message) {
                let er = error.response.data.message
                Toast.fire({ icon: 'error', title: er })
              }
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      branchRecordWithLoadSettlementData () {
        this.form.branch_id = ''
        if (this.branchFilter) {
          this.form.branch_id = this.branchFilter.id
        }
        this.loadSettlementData()
      },
      loadSettlementDataWithCustomer () {
        if (this.member) {
          this.user_id = this.member.user_id
        }
        this.loadSettlementData()
      },
      newModal () {
        $('#newModal').modal({backdrop: 'static', keyboard: false})
       // this.loadDisbursement()
      },
      getCollectionCenter () {
        this.$axios
          .get('collectioncenter?all=all&branch_id=' + this.branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
            _.forEach(this.collectionCenters, function (item, key) {
              this.collectionCenters[key].name = item.name + ' (' + item.centerCode + ')'
            }.bind(this))
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      settmentDateWise () {
        $.each(this.emiRecords, function (key, value) {
          // alert(new Date(value.emiDate).toISOString().slice(0, 10))
          if (new Date(value.emiDate).toISOString().slice(0, 10) === this.form.sattlementDate) {
            alert('hello')
          }
        })
      },
      getLoanMember () {
        // var multiplestatus = ['pending', 'processing']
        // this.colC.id = ''
        if (this.form.planType === 'group') {
          this.getCollectionCenter()
          // alert(this.colC.id)
          this.form.collection_center_id = this.colC.id
        }
        if (this.form.planType === 'individual') {
          this.collectionCenters = []
          this.colC = {}
          this.colC.id = ''
        }
        this.editMode = false
        this.memberloanplans = []
        this.mem = {}
        this.form.planName = ''
        this.form.memberName = ''
        this.form.applicationNumber = ''
        this.form.totalAmountPaidWithSettlement = 0
        this.form.planAmount = 0
        this.form.numberOfEMI = 0
        this.form.totalInstallmentPaid = 0
        this.form.totalAmountPaid = 0
        this.form.totalAmountDue = 0
        this.form.totalInstallmentDue = 0
        this.form.totalAmountDueWithoutInterest = 0
        this.form.loanPreClosingCharge = 0
        this.form.totalAmtDueWithPreClosingCharge = 0
        this.form.branch_id = this.branch.id
        this.getPaymentBranchLedgers()
        this.$axios
          .get('memberloanplan?all=all&branch_id=' + this.branch.id + '&collection_center_id=' + this.colC.id + '&searchTerm=' + this.form.planType + '&multiplestatus[]=processing&multiplestatus[]=pending', {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // console.log(data.data)
            this.memberloanplans = data.data
            _.forEach(this.memberloanplans, function (item, key) {
              if (item.status === 'pending' || item.status === 'processing') {
                this.memberloanplans[key].name = item.member.name + ' (' + item.member.code + ')' + '( Application Number - ' + item.applicationNo + ')'
                if (this.form.member_id === item.member.id) {
                  this.mem = item
                }
              }
            }.bind(this))
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      deleteModal (id) {
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            this.$axios
              .delete('sattlement/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
              .then((data) => {
                // console.log(data)
                Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
                Fire.$emit('AfterCreate')
              }).catch(function (error) { console.log(error) })
          }
        })
      },
      getMemberLoanDetail () {
        let settleLoan = []
        let sls = ''
        settleLoan = this.rows
        for (let ro = 0; ro < settleLoan.length; ro++) {
          if (settleLoan[ro].member_loan_plan_id === this.mem.id && settleLoan[ro].status === 'approved') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'This Loan is already Settled!'
            })
            sls = 'approved'
          }
        }
        var i = 0
        var emiInterest = 0
        this.partialEMIRemainder = 0
        this.form.totalAmountDueWithoutInterest = 0
        this.form.totalInstallmentPaid = 0
        this.form.totalInstallmentDue = 0
        this.form.totalAmountPaidWithSettlement = 0
        this.form.numberOfEMI = 0
        this.emitotal = 0
        this.emiRecords = []
        this.userPlan = {}
        if (sls !== 'approved') {
          this.userPlan = JSON.parse(this.mem.disbursement.plan)
          this.form.branch_id = this.mem.branch_id
          this.form.member_id = this.mem.member_id
          this.form.member_loan_plan_id = this.mem.id
          this.form.planType = this.mem.type
          this.form.planName = this.userPlan.name
          this.form.planAmount = this.mem.totalAmt
          this.form.applicationNumber = this.mem.applicationNo
          this.form.memberName = this.mem.member.name
          this.form.totalAmountPaid = this.mem.receivedAmt
          this.form.totalAmountDue = this.form.planAmount - this.form.totalAmountPaid
          this.form.sattlementDate = new Date().toISOString().slice(0, 10)
          this.$axios
            .get('memberemi?all=all&member_loan_plan_id=' + this.mem.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then((response) => response.data)
            .then((data) => {
              // console.log('record without date')
              this.emiRecords = data.data
              this.partialEMIRemainder = this.form.totalAmountPaid
              $.each(this.emiRecords, function (key, value) {
                this.emitotal += value.total
                this.form.numberOfEMI = this.form.numberOfEMI + 1
                // alert('emi total = ' + this.emitotal + ' and ' + this.form.totalAmountPaid)
                if (this.emitotal <= this.form.totalAmountPaid) {
                  this.partialEMIRemainder = this.partialEMIRemainder - value.total
                  this.form.totalInstallmentPaid = this.form.totalInstallmentPaid + 1
                  // alert('hiiiiiiii')
                } else {
                  if (i < 1) {
                    emiInterest = value.interest
                    i = i + 1
                    this.form.totalAmountDueWithoutInterest = this.form.totalAmountDueWithoutInterest - this.partialEMIRemainder
                  }
                  if (this.form.sattlementDate >= value.emiDate) {
                    this.form.amt = value.arrear
                  }
                  this.form.totalAmountDueWithoutInterest += value.principal
                }
              }.bind(this))
              this.form.totalInstallmentDue = this.form.numberOfEMI - this.form.totalInstallmentPaid
              if (emiInterest < this.partialEMIRemainder) {
                this.form.totalAmountDueWithoutInterest = this.form.totalAmountDueWithoutInterest + emiInterest
                this.form.totalAmountDueWithoutInterest = this.form.totalAmountDueWithoutInterest - this.partialEMIRemainder
              }
              if (this.form.totalAmountPaidWithSettlement < 1) {
                this.form.totalAmountPaidWithSettlement = this.form.totalAmountDueWithoutInterest
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      },
      afterAmtLoanPreClosingCharge () {
        this.form.totalAmtDueWithPreClosingCharge = parseFloat(this.form.totalAmountDueWithoutInterest) + parseFloat(this.form.loanPreClosingCharge * this.form.totalAmountDueWithoutInterest / 100)
      },
      editModal (row) {
        this.editMode = true
        this.form.fill(row)
        this.form.applicationNumber = row.member_loan_plan.applicationNo
        this.form.memberName = row.member.name
        this.afterAmtLoanPreClosingCharge()
        this.getPaymentBranchLedgers()
        // row.branch_ledger.name = row.branch_ledger.ledger.name
        // this.brLedgers.push(row.branch_ledger)
  
        // this.form.branch_ledger_id = row.branch_ledger.id
        // this.brLedger[key].name = row.branch_ledger.ledger.name
        this.$axios
          .get('disbursement/' + row.member_loan_plan.disbursement_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.dDtls = data.data.plan
            // this.dDtls = JSON.parse(data.data.plan)
            this.form.planName = JSON.parse(this.dDtls).name
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      updateLoanSettlement () {
        // console.log('update data')
        if (this.form.planType === 'group') {
          this.$delete(this.form, 'member_id')
        }
        if (this.form.planType === 'individual') {
          // alert('hello')
          this.$delete(this.form, 'center_leader_id')
          this.$delete(this.form, 'collection_center_id')
        }
        this.$axios
          .put('sattlement/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            Fire.$emit('AfterCreate')
            Toast.fire({
              icon: 'success',
              title: 'Loan Settlement Updated Successfully'
            })
            // this.editMode = false
          })
          .catch(
            function (error) {
              if (error.response.data.error) {
                var result = []
                var er = error.response.data.error
                for (var l in er) {
                  if (er.hasOwnProperty(l)) {
                    result.push(l + ': ' + er[l])
                  }
                }
                Toast.fire({ icon: 'error', title: result.join('\n') })
              }
              if (error.response.data.message) {
                let er = error.response.data.message
                Toast.fire({ icon: 'error', title: er })
              }
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      },
      loanSettlement () {
        if (this.form.planType === 'individual') {
          this.$delete(this.form, 'collection_center_id')
        }
        this.$axios
          .post('sattlement', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            Fire.$emit('AfterCreate')
            Toast.fire({
              icon: 'success',
              title: 'Dear User, Your Loan Settlemnt has been processed Successfully'
            })
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
    },
    created () {
      this.loadSettlementData()
      this.getMembers()
      this.getBranch()
      Fire.$on('AfterCreate', () => {
        this.loadSettlementData()
      })
    }
  }
  </script>



// WEBPACK FOOTER //
// LoanClosure.vue?2f4344ee